import { Component, Input, ViewChild } from '@angular/core';
import { BaseModalComponent } from 'projects/libraries/syslink-components/src/lib/modal/base-modal/base-modal.component';
import { PurchaseInvoiceHeaderStatus } from '../../purchase-invoice-header-statuses/purchase-invoice-header-status.model';
import { FilterDescriptor } from 'devextreme/data';
import { SelectComponent } from 'projects/libraries/syslink-components/src/public-api';
import { PurchaseInvoiceHeaderStatusesService } from '../../purchase-invoice-header-statuses/purchase-invoice-header-statuses.service';

@Component({
  selector: 'app-purchase-invoice-status-select-modal',
  templateUrl: './purchase-invoice-status-select-modal.component.html',
  styleUrls: ['./purchase-invoice-status-select-modal.component.scss']
})
export class PurchaseInvoiceStatusSelectModalComponent extends BaseModalComponent<PurchaseInvoiceHeaderStatus>{
  @Input() public selectFilters: FilterDescriptor | Array<FilterDescriptor>;
  @Input() public expand: FilterDescriptor | Array<FilterDescriptor>;
  @Input() public title: string = "Select invoice status";
  @Input() public content?: string;
  @Input() public data: any;
  @ViewChild('select') select?: SelectComponent;

  constructor(public purchaseInvoiceHeaderStatusesService: PurchaseInvoiceHeaderStatusesService) {
    super();
  }

}